import React from "react";

export default function ModalVoiceCallAction({ yes, no }) {
  return (
    <div className="relative">
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
        <div className="flex flex-col h-[700px] w-[300px] relative items-center justify-center">
          <div className="bg-[#215732] rounded-t-[10px] w-full max-w-md mx-auto border-[8px] border-[#215732] h-[44px] flex flex-row items-center justify-center">
            <span className="text-white text-[18px]">Leave Confirmation</span>
          </div>
          <div className="bg-white px-5 w-full max-w-md py-4 flex flex-row items-center justify-center">
            <span className="text-black text-base">
              Are you sure you want to leave the call?
            </span>
          </div>
          <div className="flex flex-row w-full">
            <div
              onClick={yes}
              className="bg-[#3BD224] rounded-bl-[10px] py-2 w-full mx-auto flex flex-row items-center justify-center"
            >
              <span className="text-white font-bold text-[18px]">Yes</span>
            </div>
            <div
              onClick={no}
              className="bg-[#EF3340] rounded-br-[10px] py-2 w-full mx-auto flex flex-row items-center justify-center"
            >
              <span className="text-white font-bold text-[18px]">No</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
